export const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <div className="relative h-10 w-10 shrink-0 rounded-xl bg-emerald-900 grid place-items-center shadow-lg shadow-emerald-900/20">
      <span className="font-display text-xl font-extrabold text-amber-400 leading-none">T</span>
      <span className="absolute -top-1 -right-1 h-3 w-3 rounded-full bg-amber-400 ring-2 ring-white" />
    </div>
    {!compact && (
      <div className="leading-tight">
        <div className="font-display text-lg font-extrabold tracking-tight text-emerald-950">Tamanna Hotels</div>
        <div className="text-[10px] font-semibold uppercase tracking-[0.22em] text-amber-700">Guest Voice Portal</div>
      </div>
    )}
  </div>
);
